// extracted by mini-css-extract-plugin
export default {"container":"EducationCard_container__lO9wE","header":"EducationCard_header__JKzaF","headerLogo":"EducationCard_headerLogo__MDpOp"};